import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchCurrentUser,
  fetchAuthProviders,
  selectAuth,
} from "../../store/slices/authSlice";
import { setAuthToken } from "../../services/api";

/**
 * AuthBootstrap — runs once at app start.
 *
 * Responsibilities:
 *   1. Wire the persisted Redux token into the axios interceptor so the
 *      first request after a refresh carries the right Authorization header.
 *   2. Refresh the current user from /auth/me (handles "I edited my profile
 *      on another device" and "my token expired while I was away").
 *   3. Fetch /auth/providers so the SignIn page knows whether to show the
 *      Google button.
 *
 * Renders nothing.
 */
export default function AuthBootstrap() {
  const dispatch = useDispatch();
  const { token } = useSelector(selectAuth);

  // Sync Redux token → axios interceptor on every change
  useEffect(() => {
    setAuthToken(token);
  }, [token]);

  // Boot-time fetches
  useEffect(() => {
    dispatch(fetchAuthProviders());
    if (token) dispatch(fetchCurrentUser());
  }, []);

  return null;
}
